export default __webpack_public_path__ + "media/music/4228d628abe613c79b2564f3111dcd83.mp3";